// src/services/location/BrowserLocationService.ts
// Implémentation réelle pour le navigateur

import { LocationService } from './types';

export class BrowserLocationService implements LocationService {
	getPathname(): string {
		return window.location.pathname;
	}

	getSearch(): string {
		return window.location.search;
	}

	getSearchParams(): URLSearchParams {
		return new URLSearchParams(window.location.search);
	}

	getOrigin(): string {
		return window.location.origin;
	}

	getHref(): string {
		return window.location.href;
	}

	hasSearchParam(key: string): boolean {
		return window.location.search.includes(`${key}=`);
	}

	getSearchParam(key: string): string | null {
		return this.getSearchParams().get(key);
	}

	matchSearchParam(pattern: RegExp): RegExpMatchArray | null {
		return window.location.search.match(pattern);
	}

	reload(): void {
		window.location.reload();
	}

	navigate(url: string): void {
		window.location.href = url;
	}
}

// Instance singleton pour usage direct (hors React)
export const browserLocation = new BrowserLocationService();
